import Viewport from "@/store/modules/Viewport";

const useResize = () => {

  let _debounce : boolean = false
  let resizeTimeout: number | null = null;
  const innerResize = () => {
    if (_debounce) {
      if (resizeTimeout) {
        clearTimeout(resizeTimeout);
      }
      resizeTimeout = setTimeout(debouncedResize, 100);
    } else {
      debouncedResize();
    }
  }
  let _callback: () => void | null;
  let previousWidth: number = Viewport.windowWidth;
  const debouncedResize = () => {
    if (previousWidth !== Viewport.windowWidth || Viewport.isDesktop) {
      previousWidth = Viewport.windowWidth;
      if (_callback) {
        _callback();
      }
    }
  }
  
  const registerResize = (callback: () => void, debounce: boolean = false) => {
    _callback = callback
    _debounce = debounce
    window.addEventListener('resize', innerResize)
  }
  const unregisterResize = () => {
    window.removeEventListener('resize', innerResize)
  }

  return {
    registerResize,
    unregisterResize,
  }
}

export default useResize;